import reducer from "./reducers"
export { default as agentActions } from "./actions"

export default reducer